import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-demande-resiliation',
  templateUrl: './demande-resiliation.component.html',
  styleUrls: ['./demande-resiliation.component.scss']
})
export class DemandeResiliationComponent implements OnInit {
  FILE_MAX_SIZE = this.configurationService.get().FILE.FILE_MAX_SIZE;
  FILE_ACCEPT_TYPE = this.configurationService.get().FILE.FILE_ACCEPT;
  EMAIL_PATTERN = this.configurationService.get().EMAIL_PATTERN;
  MAX_FILE_SELECT= this.configurationService.get().FILE.FILE_LIMIT;
  configuration= this.configurationService.get();
  fileNamePattern: RegExp = new RegExp(this.configurationService.get().global.fileNamePattern);


  constructor(private configurationService: ConfigurationService) { }

  ngOnInit(): void {
  }

}
